import React from 'react';
import { Switch } from '@headlessui/react';
import { cn } from '@/lib/utils';
import { useAHUControl } from '@/contexts/ahu-control-context';

export function PowerControl({ onChange }) {
  const { state: { power }, setPower } = useAHUControl();

  // If power state is undefined, display a placeholder or disabled state
  if (power === undefined) {
    return (
      <div className="px-2 pt-[6px] pb-[10px] bg-bg rounded-lg border border-light-grey flex flex-col gap-1 justify-between">
        <p className="text-dark-blue heading-7">Power</p>
        <div className='flex items-center'>
          <div className="relative inline-flex h-4 w-8 items-center rounded-full bg-gray-200 opacity-50">
            <span className="inline-block h-3 w-3 transform rounded-full bg-white transition translate-x-1" />
          </div>
          <span className="paragraph-11 ml-1 text-gray-400">-</span>
        </div>
      </div>
    );
  }

  return (
    <div className="px-2 pt-[6px] pb-[10px] bg-bg rounded-lg border border-light-grey flex flex-col gap-1 justify-between">
      <p className="text-dark-blue heading-7">Power</p>
      <div className='flex items-center'>
        <Switch
          checked={power}
          onChange={(e) => {
            setPower(e)
            onChange(e)
          }}
          className={cn(
            "relative inline-flex h-4 w-8 items-center rounded-full",
            power ? "bg-gradient-to-r from-primary to-green" : "bg-gray-200"
          )}
        >
          <span className="sr-only">Power</span>
          <span
            className={cn(
              "inline-block h-3 w-3 transform rounded-full bg-white transition",
              power ? "translate-x-4" : "translate-x-1"
            )}
          />
        </Switch>
        <span className={cn(
          "paragraph-11 ml-1",
          power ? "text-primary" : "text-dark-grey"
        )}>{power ? 'On' : 'Off'}</span>
      </div>
    </div>
  );
}